import { NgControl, NgControlStatus } from '@angular/forms';
import {
  Directive,
  HostBinding,
  Inject,
  Optional,
  Self,
} from '@angular/core';

import { ErrorStateMatcher, StateMatcher, WarningStateMatcher } from '../state-matcher';

@Directive({
  selector: '[formControlName],[ngModel],[formControl]', // eslint-disable-line @angular-eslint/directive-selector
  standalone: true,
})
export class ControlStatusDirective extends NgControlStatus {
  constructor(
    @Self() private readonly cd: NgControl,
    @Inject(ErrorStateMatcher) @Optional() private readonly errorStateMatcher: StateMatcher | undefined,
    @Inject(WarningStateMatcher) @Optional() private readonly warningStateMatcher: StateMatcher | undefined,
  ) {
    super(cd);
  }

  @HostBinding('class.is-danger')
  public get errorMatched(): boolean {
    return Boolean(this.errorStateMatcher?.matched(this.cd.control));
  }

  @HostBinding('class.is-warning')
  public get warningMatched(): boolean {
    return Boolean(this.warningStateMatcher?.matched(this.cd.control));
  }
}
